module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('object', {
    attrs: {
      "data": "/src/media/Nathan_Allen_Resume.pdf",
      "height": "600",
      "id": "resume_pdf",
      "width": "750"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n    To view my resume in a separate page, click\n    "), _c('a', {
    attrs: {
      "href": "/src/media/Nathan_Allen_Resume.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n       here.\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30deaffc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Resume.vue
// module id = 29
// module chunks = 0